import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import { unwrapBlobError } from '@/Network/Requests/blobError'
import type {
  CheckVerificationResponse,
  VerificationEvent
} from '@/Network/Types/Responses/CheckVerificationResponses'

/** Verificação do registro: localização e foto de biometria de um check. */
export default class DoctorCheckVerificationService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/doctor-checks'
  }

  async getVerification(checkId: number): Promise<CheckVerificationResponse> {
    try {
      const { data } = await request.get<CheckVerificationResponse>(
        this.getCompletePath(`/${checkId}/verification`)
      )
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar a verificação do registro')
    }
  }

  async getPhotoBlob(checkId: number, event: VerificationEvent): Promise<Blob> {
    try {
      const { data } = await request.get<Blob>(
        this.getCompletePath(`/${checkId}/biometry-photo/${event}/file`),
        undefined,
        undefined,
        'blob'
      )
      return data
    } catch (e) {
      throw this.handleError(
        await unwrapBlobError(e),
        'Não foi possível carregar a foto de biometria'
      )
    }
  }
}
